import type { Model } from 'awr-domain'

const GID_PATTERN = /^gid:\/\/shopify\/([A-Za-z0-9_-]+)\/([0-9]+)$/

const parseGid = (gid: string) => {
  const [, resource, idString] = gid.match(GID_PATTERN) ?? []
  if (!resource || !idString) {
    throw new Error(`Invalid GID: ${gid}`)
  }
  return {
    resource,
    id: Number(idString),
  }
}

declare global {
  interface Window {
    Shopify?: {
      routes: {
        root: string
      }
    }
  }
}

export const getShopifyCartUrl = () => {
  if (typeof window === 'undefined') {
    return null
  }

  const shopifyRoot = window.Shopify?.routes?.root
  return shopifyRoot ? `${shopifyRoot}cart` : null
}

export const addVariantsToCart = async (variants: readonly Model.ProductForCart[], configurationUrl: string) => {
  const cartUrl = getShopifyCartUrl()
  if (!cartUrl) {
    throw new Error('No Shopify cart is available')
  }

  const items = variants.map(variant => {
    const { id, resource } = parseGid(variant.id as string)
    if (resource !== 'ProductVariant') {
      throw new Error(`Only product variants can be added to the cart, got GID of type ${resource} instead`)
    }
    const properties = {
      ...(variant.additionalDescription ? { additionalDescription: variant.additionalDescription } : {}),
      ...(variant.includeConfigurationUrl ? { configurationUrl } : {}),
    }
    return {
      id,
      quantity: variant.quantity,
      properties,
    }
  })

  const formData = { items }

  const response = await fetch(`${cartUrl}/add.js`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(formData),
  })

  if (!response.ok) {
    throw new Error(`Failed to add product to cart: ${response.statusText}`)
  }
}
